/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// cSpell:ignore recarea

import { ajax } from 'rxjs/ajax';
import { concat, of } from 'rxjs';
import { map, switchMap, filter, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { STATUS } from 'sarsaparilla';

import { getRecAreaUrl } from '../api/endpoints';

import { FETCH_FACILITY_DATA_SUCCESS } from '../actions/facilityDataActions';

import {
    fetchRecAreaSuccess,
    fetchRecAreaError,
    setFetchRecAreaStatus,
} from '../actions/recAreaActions';

/**
 * Once the facility data api call is successful, we'll have the facility's
 * parentID to use to fetch the rec area data.
 *
 * The React container never calls this action directly; it is triggered automatically
 * by the success of the `fetchFacilityData.js` epic
 */
export function fetchRecAreaData(actions$) {
    return actions$.pipe(
        ofType(FETCH_FACILITY_DATA_SUCCESS),
        filter(({ payload }) => !!payload?.parent_asset_id),
        switchMap(({ payload }) => {
            const { parent_asset_id: parentId } = payload;

            return concat(
                of(setFetchRecAreaStatus(STATUS.PENDING)),
                ajax.getJSON(getRecAreaUrl(parentId)).pipe(
                    map((response) => {
                        const size = response?.size;
                        const data = response?.results?.[0];

                        if (!size || !data) {
                            return fetchRecAreaError(new Error('Rec area not found'));
                        }

                        return fetchRecAreaSuccess(data);
                    }),
                    catchError((error) => of(fetchRecAreaError(error)))
                )
            );
        })
    );
}
